import {Component, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {ContentHeader} from "app/layout/components/content-header/content-header.component";


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent implements OnInit, OnDestroy {

  public contentHeader: ContentHeader

  public searchText: string;

  public topics = [];

  constructor() {
  }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'FAQ',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/home'
          },
          {
            name: 'FAQ',
            isLink: false
          }
        ]
      }
    };

    this.topics.push({
      icon: 'credit-card',
      title: 'Modalità di pagamento',
      subtitle: '',
      qanda: [
        {
          question: '1. PausePay – Come funziona?',
          answer: '<b>PausePay</b> è il primo metodo di pagamento online B2B dilazionato, con bonifico a 90 giorni in unica soluzione dalla data di acquisto del prodotto/credito. Grazie al bonifico dilazionato, irrevocabile, non sei vincolato da alcun plafond legato alla carta di credito.' +
            '<ol type="a">' +
            '<li>Aggiungi al carrello gli articoli da acquistare;</li>' +
            '<li>In fase di check-out scegli <b>PausePay</b></li>' +
            '<li>Se è la tua prima volta, registrati e scegli la tua banca da utilizzare per il pagamento tramite <b>Open Banking</b>;</li>' +
            '<li>Se accettato, autorizza il pagamento irrevocabile dilazionato a 90 giorni.</li>' +
            '</ol>' +
            '<p>Se hai ancora dei dubbi visita le <a href="https://pausepay.it/faq/" target="_blank">Domande Frequenti</a> di PausePay</p>'
        },
        {
          question: '2. Disponibilità – Che cos’è?',
          answer: 'La Disponibilità è un portafoglio virtuale a disposizione del Cliente che può essere utilizzato per l’acquisto dei prodotti sulla piattaforma, selezionando ‘usa il tuo wallet’ nel carrello in fase di acquisto.\n' +
            'La disponibilità presente nel portafoglio digitale può aumentare:' +
            '<ul>' +
            '<li>Attraverso l’acquisto di Buoni Spesa che verranno accreditati nel portafoglio virtuale.</li>' +
            '<li>Attraverso l’accredito del Cashback durante l’acquisto di prodotti e/o servizi</li>' +
            '<li>Il cashback è un rimborso percentuale che ti verrà accreditato al momento dell’acquisto di prodotti e/o servizi, laddove previsto ed evidenziato.</li>' +
            '</ul>'
        },
        {
          question: '3. Posso scegliere la modalità di pagamento che preferisco?',
          answer: 'Potrai scegliere la modalità di pagamento che preferisci tra quelle disponibili in fase di acquisto.</br>' +
            'Alcune modalità di pagamento sono disponibili a seconda del magazzino o della tipologia del prodotto.'
        }
      ]
    })

    this.topics.push({
      icon: 'refresh-cw',
      title: 'Resi e Garanzie',
      subtitle: '',
      qanda: [
        {
          question: '1. Criteri per l’accettazione del reso',
          answer: 'Per l’accettazione del reso:' +
            '<ul>' +
            '<li>Il prodotto non deve esser stato montato;</li>' +
            '<li>Il Prodotto deve essere inserito nel suo imballo originale completo e non danneggiato;</li>' +
            '<li>L’ imballo originale deve essere inserito in un’idonea confezione di protezione.</li>' +
            '</ul>'
        },
        {
          question: '2. Tempistiche per effettuare la richiesta di reso?',
          answer: 'Reso standard: il cliente ha 14 giorni di tempo per effettuare il reso dei prodotti dalla data di consegna.</br>' +
            'Reso in Garanzia: il cliente ha 1 anno dalla data di consegna per effettuare la richiesta di garanzia.'
        },
        {
          question: '3. Costi resi e garanzie',
          answer: 'I resi e le garanzie dei ricambi auto sono gratuiti.</br>' +
            'Per gli pneumatici le spese di spedizione legate al reso ammontano a 12 Euro a collo.'
        },
        {
          question: '4. Dove trovo i documenti utili al reso?',
          answer: 'Il modulo apposito per la richiesta di reso è reperibile e scaricabile nell’area riservata del cliente nella sezione resi e garanzie.'
        },
        {
          question: '5. Modalità di richiesta reso',
          answer: '<ul>' +
            '<li>Compila l’apposito modulo, con i dati richiesti. Invia il modulo, insieme al Ddt, all’indirizzo e-mail <a href="mailto:warranty@tulero.it">warranty@tulero.it</a> – il dipartimento Warranty di Tulero ordinerà il ritiro del tuo reso;</li>' +
            '<li>Il prodotto reso non deve presentare segni di montaggio o danni visibili.</li>' +
            '<li>Inserisci il Prodotto nel suo imballo d’origine completo e non danneggiato;</li>' +
            '<li>Inserisci l’imballo d’origine in un’idonea confezione di protezione;</li>' +
            '<li>Consegna al Vettore il prodotto corredato da Ddt e dal modulo di reso e garanzia compilati in ogni sua parte.</li>' +
            '</ul>'
        },
        {
          question: '6. Resi Batterie d’accensione',
          answer: 'Il diritto di reso non può essere applicato alle batterie. Essendo materiale di difficile movimentazione, Matheria srl non riconosce il diritto di recesso per le batterie.'
        },
        {
          question: '7. Resi Serbatoi GPL',
          answer: 'Il diritto di reso non può essere applicato ai serbatoi GPL. Essendo materiale di difficile movimentazione, Matheria srl non riconosce il diritto di recesso per i serbatoi GPL.'
        }
      ]
    })

    this.topics.push({
      icon: 'package',
      title: 'Ordini',
      subtitle: '',
      qanda: [
        {
          question: '1. Modalità di ricerche attive sulla piattaforma',
          answer: 'I prodotti possono essere ricercati tramite:' +
            '<ul>' +
            '<li>Targa</li>' +
            '<li>Albero veicoli</li>' +
            '<li>Codice Originale/After Market</li>' +
            '<li>Ricerca testuale</li>' +
            '</ul>'
        },
        {
          question: '2. Posso annullare un ordine che ho erroneamente inviato?',
          answer: 'Gli ordini possono essere annullati entro 10 minuti dal loro invio. Passati i 10 minuti Tulero non può garantire il successo dell’annullamento.'
        }
      ]
    })
    
    this.topics.push({
      icon: 'list',
      title: 'Fatturazione',
      subtitle: '',
      qanda: [
        {
          question: '1. Ogni quanto emettiamo fattura?',
          answer: 'Emettiamo la tua fattura ogni 10 gg con pagamento con riba, mentre se come modalità di pagamento hai scelto carta di credito, bonifico immediato o Tulero Wallet la tua fattura è immediata.'
        }
      ]
    })
  }
  

  ngOnDestroy(): void {

  }

}
